import cx from "classnames";
import Link from "next/link";
import { useState } from "react";

import { ProductPageProps } from "./page";
import TipsCollapseIcon from "./tips-collapse.svg";

export const TipsList = ({
  title,
  familyCategories,
  familySlug,
}: {
  title?: string;
  familyCategories: ProductPageProps["productData"]["family"]["tips"];
  familySlug: string;
}) => {
  const [selectedCategory, setSelectedCategory] = useState<string>();

  return (
    <div>
      {title && <h3 className="mb-5 text-xl font-bold md:text-2xl">{title}</h3>}

      {familyCategories?.map((category) => (
        <div
          key={category?.id}
          className="overflow-hidden border-b border-black/10"
        >
          <div
            className="flex gap-2 items-center py-4 cursor-pointer"
            onClick={() =>
              setSelectedCategory(
                category?.id == selectedCategory ? undefined : category?.id,
              )
            }
          >
            <div
              className={cx(
                "transition-all",
                selectedCategory == category?.id && "rotate-90",
              )}
            >
              <TipsCollapseIcon />
            </div>
            <h3 className="text-lg">{category?.name}</h3>
          </div>

          <ul
            className={cx(
              "flex flex-col gap-3",
              selectedCategory == category?.id ? "h-auto -mt-2 mb-3" : "h-0",
            )}
          >
            {category?.articles?.map((article: any) => (
              <li
                key={article?.slug}
                className="ml-9 w-fit leading-5 text-cornflower-blue hover:underline first-letter:uppercase md:text-lg"
              >
                <Link href={`/smartphone/${familySlug}/tips/${article?.slug}`}>
                  <a>{article?.name}</a>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};
